module.exports = __webpack_public_path__ + "static/media/BrandonGrotesque-Regular.3481dcfe.otf";